'use strict';

var $ = require('jquery');
var page = $([document.documentElement, document.body]);
var categoryToggleButtons = [];

$(function() {
    // Main category buttons on the archive page
    $('.category-toggle').each(function() {
        // Make an array of all the category buttons
        categoryToggleButtons.push(this);

        $(this).click(function() {
            if ($(this).hasClass('open'))
                closeCategory(this);
            else 
                openCategory(this);

            // Always close other categories, if another one is clicked
            closeOtherCategories(this);
        });
    });

    // "Filter" buttons inside categories
    $('.category-filter-item.category').each(function() {
        $(this).click(function() {
            var targetCategory = $('.category-toggle.'+$(this).data('cat'))[0];

            if(!$(targetCategory).hasClass('open')) {
                openCategory(targetCategory);
                closeOtherCategories(targetCategory);
            }
        });
    });

    // Filter close buttons
    $('.category-filter-toggle').each(function() {
        $(this).click(function() {
            var targetCategory = $(this).closest('.category').find('.category-toggle')[0];
            closeCategory(targetCategory);
            closeOtherCategories(targetCategory)
        });
    });
});

function closeCategory(button) {
    $(button).closest('.category').find('.category-content').slideUp();
    $(button).removeClass('open');
}

function openCategory(button) {
    // Scroll window to the opened category
    var position;
    // If some other category was opened and it is lower on the page than the currently opened category, calculate position
    if ($(button).hasClass('fade') && $(button).offset().top > $('button.open').offset().top)
        position = $(button).offset().top - $('button.open').closest('.category').find('.category-content').outerHeight(true);
    else 
        position = $(button).offset().top;
    scrollWindowTo(position);

    // Change classes of the active category
    $(button).removeClass('fade').addClass('open');
    $(button).closest('.category').find('.category-content').slideDown(400);
}

function closeOtherCategories(button) {
    categoryToggleButtons.forEach(categoryButton => {
        // Skip curren button
        if (categoryButton === button)
            return;

        closeCategory(categoryButton);

        if($(button).hasClass('open'))
            $(categoryButton).addClass('fade');
        else 
            $(categoryButton).removeClass('fade');
    });
}

function scrollWindowTo(coords) {
    // Stop animating scroll, if user manually scrolls
    page.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function(){
        page.stop();
    });

    $(page).animate({ scrollTop: coords }, 500, function() {
        page.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
    });
}